export default __webpack_public_path__ + "static/media/gameBg2.6a6367c7.png";